// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ISpendPeriodTypePropertyDto
 */
export interface ISpendPeriodTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof ISpendPeriodTypePropertyDto
     */
    spend_period_type?: ISpendPeriodTypePropertyDtoSpendPeriodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ISpendPeriodTypePropertyDto
     */
    spend_period_type_state?: ISpendPeriodTypePropertyDtoSpendPeriodTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum ISpendPeriodTypePropertyDtoSpendPeriodTypeEnum {
    UNLIMITED = 'UNLIMITED',
    MONTHLY = 'MONTHLY',
    PLAN_YEAR = 'PLAN_YEAR'
}
/**
* @export
* @enum {string}
*/
export enum ISpendPeriodTypePropertyDtoSpendPeriodTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the ISpendPeriodTypePropertyDto interface.
 */
export function instanceOfISpendPeriodTypePropertyDto(value: object): value is ISpendPeriodTypePropertyDto {
    return true;
}

export function ISpendPeriodTypePropertyDtoFromJSON(json: any): ISpendPeriodTypePropertyDto {
    return ISpendPeriodTypePropertyDtoFromJSONTyped(json, false);
}

export function ISpendPeriodTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ISpendPeriodTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'spend_period_type': json['spend_period_type'] == null ? undefined : json['spend_period_type'],
        'spend_period_type_state': json['spend_period_type_state'] == null ? undefined : json['spend_period_type_state'],
    };
}

export function ISpendPeriodTypePropertyDtoToJSON(json: any): ISpendPeriodTypePropertyDto {
    return ISpendPeriodTypePropertyDtoToJSONTyped(json, false);
}

export function ISpendPeriodTypePropertyDtoToJSONTyped(value?: ISpendPeriodTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'spend_period_type': value['spend_period_type'],
        'spend_period_type_state': value['spend_period_type_state'],
    };
}

